export default `
@-webkit-keyframes pulse {
    0% {
      -webkit-box-shadow: 0 0 0 0 rgb(249,38,79);
    }
    70% {
        -webkit-box-shadow: 0 0 0 10px rgba(249,38,79, 0);
    }
    100% {
        -webkit-box-shadow: 0 0 0 0 rgba(249,38,79, 0);
    }
  }
  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 rgb(249,38,79);
      box-shadow: 0 0 0 0 rgb(249,38,79);
    }
    70% {
        -moz-box-shadow: 0 0 0 10px rgba(249,38,79, 0);
        box-shadow: 0 0 0 10px rgba(249,38,79, 0);
    }
    100% {
        -moz-box-shadow: 0 0 0 0 rgba(249,38,79, 0);
        box-shadow: 0 0 0 0 rgba(249,38,79, 0);
    }
  }

  @keyframes float {
    from { transform: translate(0,  0px); }
    50%  { transform: translate(0, 15px); }
    to   { transform: translate(0, -0px); }    
}
`